import React, { ReactNode } from "react";

export interface TestCourseDialogProps {
  component: () => React.ReactNode;
}

export function TestCourseDialog(props: TestCourseDialogProps) {
  return (
    <div className="">
      <div className="w-full flex items-end justify-end"></div>
      <div className="">{props.component()}</div>
    </div>
  );
}
